import { Component, inject, Input, OnInit } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'marketing-popup',
    imports: [],
    templateUrl: './marketing-popup.component.html',
    styleUrl: './marketing-popup.component.scss'
})
export class MarketingPopupComponent implements OnInit {

    #modalService = inject(BsModalService)
    #sanitizer = inject(DomSanitizer)

    @Input() modalId: string
    @Input() popup: any

    safeUrl!: SafeResourceUrl;

    ngOnInit(): void {

        if (!this.popup?.CONTENTURL) {
            console.warn("Marketing popup is missing 'CONTENTURL'.", this.popup)
            this.close()
        }

        this.safeUrl = this.#sanitizer.bypassSecurityTrustResourceUrl(this.popup?.CONTENTURL)

        if (this.popup?.SECONDSTODISPLAYPOPUP > 0) {
            setTimeout(() => { this.close() }, this.popup.SECONDSTODISPLAYPOPUP * 1000)
        }
    }

    close(): void {
        this.#modalService.hide(this.modalId)
    }
}
